<template>
  <div class="content mt-56">
    <div class="filter-row">
      <div class="filter-row-content">
        <div
          class="filter-item-wrap"
          v-for="(item, index) in statusList"
          :key="index"
        >
          <div
            class="item-bottom-10 filter-item"
            @click="statusSelect(item, index)"
            :class="{ 'select-item': activeStatus == item.value }"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="nodata-container" v-if="!couponList.length">
      <img src="@/static/coupon_empty.png" alt />
      <div class="S6 T3">暂无此类型优惠券</div>
    </div>
    <ul class="payment-mode-list T3" v-else>
      <li
        v-for="(item, index) in couponList"
        :key="index"
        class="payment-mode payment-mode--disable"
      >
        <div class="T1 flex">
          <div class="left-count text-center">
            <div class="S4">
              ￥<span class="S10 font-bold">{{ item.valueAmount }}</span>
            </div>
            <div class="S4 min-limit">
              {{
                item.minLimitAmount
                  ? `满${item.minLimitAmount}可用`
                  : '无门槛优惠券'
              }}
            </div>
          </div>
          <div class="right-count">
            <div class="S8 mb-20 name">{{ item.name }}</div>
            <div class="S4">
              {{ dayjs(item.validFrom).format('YYYY.MM.DD') }} ~
              {{ dayjs(item.validEnd).format('YYYY.MM.DD') }}
            </div>
          </div>
        </div>
        <div
          class="click-btn"
          :class="item.status === 3 ? 'expired' : ''"
        ></div>
      </li>
    </ul>
  </div>
</template>
<script>
import {
  ref,
  reactive,
  onMounted,
  toRefs,
  computed,
  defineComponent
} from '@vue/composition-api'
import api from '@/api/api'
import { getClientInfo, onResume } from '@em/ym'
import dayjs from 'dayjs'
export default defineComponent({
  name: 'DisabledCoupon',
  setup() {
    const couponList = ref([])
    const state = reactive({
      viewState: '',
      activeStatus: 1,
      statusList: [
        { name: '已使用', value: 1 },
        { name: '已过期', value: 3 }
      ]
    })
    const activeStatusVal = computed(
      () => state.statusList.find(a => a.value === state.activeStatus).value
    )
    onMounted(() => {
      getCouponData()
      onResume(() => {
        getClientInfo(() => {
          getCouponData()
        })
      })
    })
    async function getCouponData() {
      const { detail, result } = await api.coupon.getCouponApi(
        {
          direction: state.viewState ? 2 : 0,
          statusList:
            activeStatusVal.value === 1 ? [1, 2] : [activeStatusVal.value]
        },
        state.viewState
      )
      if (result.code === 0) {
        couponList.value = detail.list
      }
    }
    function statusSelect(item) {
      state.activeStatus = item.value
      state.viewState = ''
      getCouponData()
    }
    return {
      ...toRefs(state),
      couponList,
      statusSelect,
      dayjs
    }
  }
})
</script>
<style lang="scss" scoped>
.content {
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  height: 100vh;

  .title {
    padding-bottom: 20px;
  }
}
.flex {
  display: flex;
}
.text-center {
  text-align: center;
}
.min-limit {
  margin-top: 18px;
  padding-left: 10px;
}
.payment-mode-list {
  list-style: none;
  padding: 0;
  margin: 0;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  .payment-mode {
    position: relative;
    height: 156px;
    display: flex;
    align-items: center;
    margin-bottom: 21px;
    background: url('./images/bg.png') no-repeat center;
    background-size: cover;
    pointer-events: none;

    .click-btn {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 86px;
      height: 86px;
      background: url('./images/used.png') no-repeat center;
      background-size: contain;
      &.expired {
        background-image: url('./images/expired.png');
      }
    }

    .left-count {
      flex: 0 0 180px;
    }
    .right-count {
      flex: 0 0 100%;
      padding-left: 64px;
    }
    .name {
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: bold;
    }
  }
}
.filter-row {
  align-items: flex-start;
  display: flex;
  margin-bottom: 6px;
  margin-top: 40px;
}

.filter-row-content {
  display: flex;
  align-items: center;
  align-content: space-between;
  flex-flow: row wrap;
  flex: 1;
  div {
    font-size: 24px;
    color: #858585;
  }
  .select-item {
    border: 1px solid #0079ff;
    color: #0079ff;
    background: #ffffff;
  }
}
.filter-item-wrap {
  width: 22%;
  margin-right: 3%;
  &:nth-child(4n) {
    margin-right: 0;
  }
}
.filter-item {
  height: 50px;
  color: #858585;
  background-color: rgba(85, 85, 85, 0.1);
  border-radius: 5px;
  text-align: center;
  line-height: 50px;
  letter-spacing: 1px;
  cursor: pointer;
  flex: none;
  box-sizing: border-box;
}

.item-bottom-10 {
  margin-bottom: 24px;
}

.select-item {
  border: 1px solid #0079ff;
  color: #0079ff;
  background: #ffffff;
}
.nodata-container {
  width: 100%;
  height: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nodata-container img {
  width: 402px;
  height: 194px;
  margin-bottom: 26px;
}
</style>
